import { render, staticRenderFns } from "./OrdersFilters.vue?vue&type=template&id=5048afaf&scoped=true"
import script from "./OrdersFilters.vue?vue&type=script&lang=js"
export * from "./OrdersFilters.vue?vue&type=script&lang=js"
import style0 from "./OrdersFilters.vue?vue&type=style&index=0&id=5048afaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5048afaf",
  null
  
)

export default component.exports